import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import AppsTemplate from '@/components/templates/AppsTemplate';
import { getStaticPageData } from '@/services/getPageData';

export interface AppsProps {
  title: string;
  description: string;
  url: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contentBlocks: { type: string; value: any }[];
  noindex: boolean;
}

const Apps: NextPage<AppsProps> = props => {
  const { title, description, url, noindex } = props;

  return (
    <>
      <HeadMeta title={title} description={description} url={url} noindex={noindex} />
      <AppsTemplate {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  try {
    const pageData = await getStaticPageData({ locale, url_path: 'apps' });

    if (isEmpty(pageData) || isEmpty(pageData.metadata)) {
      return {
        notFound: true,
        revalidate: true,
      };
    }

    const { seo_title, title, seo_description, url, content_blocks, canonical_url } =
      pageData.metadata;

    return {
      props: {
        title: seo_title ?? title,
        description: seo_description,
        url: url ?? canonical_url,
        contentBlocks: content_blocks,
        noindex: !!pageData.fallback,
      },

      revalidate: 20,
    };
  } catch {
    return {
      notFound: true,
      revalidate: true,
    };
  }
};

export default Apps;
